import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

/** winepassport#343 / #354 — mapa provincia -> localidades de Argentina. */
export type LocalityCatalog = Record<string, string[]>;

@Injectable({
  providedIn: 'root',
})
export class LocalityService {
  apiName = 'Default';

  // El catálogo es estático; se pide una sola vez por sesión.
  private catalog$?: Observable<LocalityCatalog>;

  getAll = (config?: Partial<Rest.Config>): Observable<LocalityCatalog> => {
    if (!this.catalog$) {
      this.catalog$ = this.restService
        .request<any, LocalityCatalog>(
          { method: 'GET', url: '/api/app/locality' },
          { apiName: this.apiName, ...config },
        )
        .pipe(shareReplay(1));
    }
    return this.catalog$;
  };

  constructor(private restService: RestService) {}
}
